var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SCheckbox',{staticClass:"terms",attrs:{"label":`${_vm.termsText} this item, you acknowledge to arrange both payment and delivery details with your transaction partner.`,"input":_vm.checkBox,"data-cy":_vm.dataCy},on:{"change":function($event){return _vm.$emit('check', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }